import { Stack } from 'expo-router';
import Head from 'expo-router/head';

import { TmpScreenV2List_ } from '@fhs/menu/src/screens/_tmp-screen-v2-list';
import { isNative } from '@fhs-legacy/frontend/src/utils/environment';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function V2IndexPage() {
  return (
    <>
      <Head>
        <title>V2 - Firehouse Subs</title>
      </Head>
      <Stack.Screen options={{ headerShown: isNative }} />
      <TmpScreenV2List_ />
    </>
  );
}
